class EsPdpUpsell extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      shareContent: ".es-pdp-upsell-modal",
      openBtn: "[data-open-pdp-upsell-modal]"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { shareContent } = this.domNodes;
    if (shareContent && shareContent.innerHTML) {
      this.shareContent = shareContent.innerHTML;
      this.init();
    }
  }

  init() {
    if (this.domNodes.openBtn) {
      this.domNodes.openBtn.classList.remove("m:hidden");
    }
    
    this.modal = new MinimogTheme.Modal();
    
    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        if (this.shareContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("m-sharing__content");
          contentElement.innerHTML = this.shareContent;
          
          // Get product information from the clicked element
          const productElement = e.target.closest('[data-open-pdp-upsell-modal]');
          const productId = e.target.closest('[data-product-id]').dataset.productId;
          const productTitle = e.target.closest('[data-product-title]').dataset.productTitle;
          const productPrice = e.target.closest('[data-product-price]').dataset.productPrice;
          const productDescription = e.target.closest('[data-product-description]').dataset.productDescription;
          const productImage = productElement.dataset.productImage;
          
          // Update modal content with product information
          contentElement.querySelector('#es-pdp-upsell-modal-title').textContent = productTitle;
          contentElement.querySelector('#es-pdp-upsell-modal-price').textContent = productPrice;
          contentElement.querySelector('#es-pdp-upsell-modal-description').innerHTML = productDescription;
          // Update product image
          const imageContainer = contentElement.querySelector('#es-pdp-upsell-modal-image');
          imageContainer.innerHTML = `<img src="${productImage}" alt="${productTitle}" style="width:100%; height:auto;">`;
          // You can add more product details here as needed
          
          this.modal.appendChild(contentElement);
          this.modal.setSizes("es-pdp-upsell-modal");
          this.modal.open();
        }
      }
    });
  }
}

customElements.define("es-pdp-upsell-modal", EsPdpUpsell);
